export const MY_MEDICAL_MAKE_A_CLAIM = "My Medical - Make A Claim"
export const MY_MEDICAL_POPUP = (popupTitle: string) => `My Medical - Popup - ${popupTitle}`
export const MY_MEDICAL = "My Medical"
export const ACTIVATION_CODE = "Activation Code"
